import { TableBodyProps, Tbody } from "@chakra-ui/react";
import { FC } from "react";

export const MobileTableBody: FC<TableBodyProps> = ({ children, ...rest }) => (
  <Tbody {...rest} display={["table-row-group", "table-row-group", "none"]}>
    {children}
  </Tbody>
);
